// src/components/Equipe.js
import React from 'react';
import './Equipe.css';

const Equipe = () => {
  const membros = [
    { nome: 'Ester Miriã de Sousa Freire', cargo: 'Cientista da Computação / CEO', descricao: '4 anos de experiência em tecnologia, liderando o desenvolvimento da plataforma AgroVacina.', icon: 'fas fa-laptop-code', cor: '#4caf50' },
    { nome: 'Amanda Liz', cargo: 'Médica Veterinária', descricao: 'Especialista em sanidade animal e bem-estar do rebanho, responsável pelos protocolos de vacinação.', icon: 'fas fa-user-md', cor: '#2196f3' },
    { nome: 'Juan Cortez', cargo: 'UI/UX Designer', descricao: 'Designer focado em experiências intuitivas para o usuário rural, garantindo usabilidade da plataforma.', icon: 'fas fa-palette', cor: '#ff9800' },
    { nome: 'Pedro Queiroz', cargo: 'Front-end Developer', descricao: 'Desenvolvedor especializado em aplicações móveis para o campo, focando em performance e acessibilidade.', icon: 'fas fa-code', cor: '#9c27b0' },
    { nome: 'Ana Beatriz', cargo: 'Back-end Engineer', descricao: 'Engenheira de software com foco em sistemas de grande escala, garantindo a estabilidade da plataforma.', icon: 'fas fa-server', cor: '#607d8b' },
    { nome: 'Daniel Duarte', cargo: 'Doutor em Biotecnologia', descricao: 'Pesquisador com expertise em inovações para saúde animal, responsável pela validação científica da solução.', icon: 'fas fa-dna', cor: '#795548' }
  ];

  return (
    <section id="equipe" className="section">
      <div className="container">
        <span className="section-eyebrow">Time</span>
        <h2 className="section-title">Conheça Nossa Equipe de Especialistas</h2>

        <div className="equipe-container">
          {membros.map((membro, index) => (
            <div key={index} className="membro-card">
              <div className="membro-icon" style={{ backgroundColor: membro.cor }}>
                <i className={membro.icon}></i>
              </div>
              <div className="membro-info">
                <h3 className="membro-nome">{membro.nome}</h3>
                <div className="membro-cargo">{membro.cargo}</div>
                <p className="membro-descricao">{membro.descricao}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Equipe;